// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3MJVU","log":"ModalInventoryLogs_log__1UcDC","date":"ModalInventoryLogs_date__1SWVE","userName":"ModalInventoryLogs_userName__PswDJ"};